import Icon from '@components/v2/ui/Icon/Icon';
import Tooltip from '@components/v2/ui/Tooltip/Tooltip';
import { Box } from '@mui/material';
import { CircleAlert } from 'lucide-react';
import LangEnum from '../../../../../../../lang/LangEnum';
import { useTranslation } from '../../../../../../translation/TranslationContext';

const CatalogNavigationLockAlert = () => {
  const { translate } = useTranslation();

  return (
    <Tooltip TooltipContent={translate(LangEnum.CATALOGS_NAVIGATION_PREFERENCES_DISABLED_TOOLTIP)}>
      <Box sx={{ display: 'inline-flex', color: 'text.secondary' }}>
        <Icon icon={CircleAlert} size="sm" />
      </Box>
    </Tooltip>
  );
};

export default CatalogNavigationLockAlert;
